import _ from 'lodash'
import Config from '../api/config'
export default {
  computed: {
    // Button utility methods
    '$btn' () {
      return {
        disable (identifier) {
          const button = document.querySelector(identifier)
          button.classList.add('ml-btn--disabled')
          button.disabled = true
        },
        enable (identifier) {
          const button = document.querySelector(identifier)
          button.disabled = false
          button.classList.remove('ml-btn--disabled')
        }
      }
    },
    error () {
      const error = Config.ERROR_MESSAGES[this.errorStatCode]
      if (error === undefined) {
        return this.errorFallbackMessage
      }
      return error
    }
  },
  data () {
    return {
      showError: false,
      errorStatCode: 7,
      errorFallbackMessage: Config.ERROR_MESSAGES[7]
    }
  },
  methods: {
    hideErrorMsg () {
      this.showError = false
    },
    goTo (path) {
      if (!this.loading) {
        this.$router.push(path)
      }
    },
    showErrorMsg (reason) {
      this.errorStatCode = reason.STATCODE
      this.errorFallbackMessage = _.capitalize(reason.REASON)
      this.showError = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Global.js